/**
 * @ngdoc directive
 * @name WcResponsiveTableModule.directive:wcExportToExcel
 * @description
 * The wcExportToExcel directive is responsible for export the whole table to xlsx.
 */


angular.module('WebCoreModule').directive('wcExportToExcel', ['$window', 'XLSX', 'saveAs', '_', 'WcTranslateConfiguratorService', function($window, XLSX, saveAs, _, WcTranslateConfiguratorService) {
    return {
        restrict: 'E',
        template: '<button type="button" class="btn icon icon-excel" ng-click="exportToXslxController.makeExcel()" aria-label="{{"exportTo.excelButtonAriaLabel" | translate}}"> <i class="fa fa-file-excel-o"  aria-hidden="true" title="{{"exportTo.excelButtonTitle" | translate}}"></i><span class="hidden-xs">{{"exportTo.excelButtonText" | translate}}</span></button>',
        replace: true,
        require: ['wcExportToExcel'],
        scope: {},
        controllerAs: 'exportToXslxController',
        controller: [ '$scope', '$element',  function($scope, $element){
            WcTranslateConfiguratorService.loadPartAndRefresh('WC-dataTable');

            var responsiveTableController = $element.parent().controller('wcResponsiveTable');
            responsiveTableController = responsiveTableController || $scope.responsiveTableController || $scope.$parent.responsiveTableController;

            this.exportToExcel = function(columnHeadText, dataAttributes, tableId) {
                var collection = responsiveTableController.WcTableCollectionService.getCollection();
                var collectionLength = collection.length;

                var exportArray = [];

                //Add header text to data to export
                exportArray.push(columnHeadText);
                //Assemble row data from the collection array in export array
                var rowLen = exportArray[0].length;
                for (var r = 0; r < collectionLength; ++r) {
                    var row = [];
                    for (var c = 0; c < rowLen; c++) {
                        var value = _.get(collection[r], dataAttributes[c]);
                        row.push(value);
                    }
                    exportArray.push(row);
                }

                //tableId to identify the export and filename
                tableId = tableId.toString();
                var fileName = tableId + ".xlsx";

                //Set up xlsx workbook/worksheet objects to be written to distributable workbook
                var workbook = {SheetNames:[], Sheets:{}}, worksheet = this.sheetFromArrayOfArrays(exportArray);

                //Add column width details
                var wsColumnWidths = [];
                for(var c = 0; c < dataAttributes.length; ++c){
                    var wch = {};
                    var maxLength = 0;
                    maxLength = Math.max.apply(Math, exportArray.map(function (v) {
                        if(v[c]==null) return 0;
                        return v[c].toString().length;
                    }));
                    wch['wch'] = maxLength;
                    wsColumnWidths.push(wch);
                }
                worksheet['!cols'] = wsColumnWidths;

                //Can be expanded to use cell ranges (merged cells), at the moment including '!merges' ranges as a formality
                var ranges = [];
                worksheet['!merges'] = ranges;

                //Add Sheet to Workbook
                workbook.SheetNames.push(tableId);
                workbook.Sheets[tableId] = worksheet;

                var outWorkbook = XLSX.write(workbook, {type:'binary'});
                saveAs(new $window.Blob([this.s2ab(outWorkbook)],{type:"application/octet-stream"}), fileName);
            };

            this.s2ab = function(s){
                if(typeof ArrayBuffer !== 'undefined') {
                    var buf = new ArrayBuffer(s.length);
                    var view = new Uint8Array(buf);
                    for (var i=0; i!=s.length; ++i) view[i] = s.charCodeAt(i) & 0xFF;
                    return buf;
                } else {
                    var buf = new Array(s.length);
                    for (var i=0; i!=s.length; ++i) buf[i] = s.charCodeAt(i) & 0xFF;
                    return buf;
                }
            };

            this.sheetFromArrayOfArrays = function(data){
                var ws = {};
                var range = {s: {c:10000000, r:10000000}, e:{c:0, r:0}};
                for(var R = 0; R!=data.length; ++R){
                    for(var C = 0; C!=data[R].length; ++C){
                        if(range.s.r > R) range.s.r = R;
                        if(range.s.c > C) range.s.c = C;
                        if(range.e.r < R) range.e.r = R;
                        if(range.e.c < C) range.e.c = C;
                        var cell = {v: data[R][C] };
                        if(cell.v == null) continue;
                        var cell_ref = XLSX.utils.encode_cell({c:C,r:R});

                        if(typeof cell.v === 'number') cell.t = 'n';
                        else if(typeof cell.v === 'boolean') cell.t = 'b';
                        else if(cell.v instanceof Date) {
                            cell.t = 'n'; cell.z = XLSX.SSF._table[14];
                            cell.v = this.dateNum(cell.v);
                        }
                        else cell.t = 's';
                        ws[cell_ref] = cell;
                        if(R===0) {ws[cell_ref]['bold'] = true;}
                    }
                }
                if(range.s.c < 10000000) ws['!ref'] = XLSX.utils.encode_range(range);
                return ws;
            };

            //Formats a passed in date (v) for excel export
            this.dateNum = function(v/*:Date*/, date1904/*:?boolean*/)/*:number*/ {
                var epoch = v.getTime();
                if(date1904) epoch += 1462*24*60*60*1000;
                return (epoch + 2209161600000) / (24 * 60 * 60 * 1000);
            };

            this.makeExcel = function(){

                //get table headers
                var tableId = responsiveTableController.id;

                //Gather column Header text and names of associated data
                var columnHeaders =  $(responsiveTableController.table).find('th');
                var columnHeadText = [];

                for (var i=0; i<columnHeaders.length; i++){
                    var text = $(columnHeaders[i]).find('.header-text').text();
                    if (text !== "Actions" && text.trim() !== "" ){
                        columnHeadText.push(text);
                    }
                }

                var firstRowData = $(responsiveTableController.table).find('tbody tr:first-child td');
                var dataAttributes = [];

                for (var c=0; c<columnHeaders.length; c++){
                    if(firstRowData[c].getAttribute('ng-bind')){
                        var attr = firstRowData[c].getAttribute('ng-bind');
                        dataAttributes.push(attr.substr(attr.indexOf('.')+1));
                    } else if(columnHeaders[c].getAttribute("wc-column-sort")){
                        dataAttributes.push(columnHeaders[c].getAttribute('wc-column-sort'));
                    }
                }

                this.exportToExcel(columnHeadText, dataAttributes, tableId);
            };
        }]
    };
}]);

